/* eslint-disable */
import React from 'react'
import HeaderTablePrint from './HeaderTablePrint'
import {accounting} from 'accounting'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'

class ProductFactorPrintComponent extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}

  render() {
    let columns = ['ردیف', 'شناسه فاکتور', 'شماره فاکتور', 'تعداد', 'مقدار', 'واحد', 'قیمت کل', 'تخفیف', 'قابل پرداخت']
    let reporterName = cookie.load('name')
    let {aggregation, printInfo, headerTitlePrint, centerSectionPrint, rightSectionPrint} = this.props

    return (
      <div className="printSection">
        <table className="printTable printReportTable">
          <HeaderTablePrint
            header={headerTitlePrint}
            reporter={reporterName}
            timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
            headerColSpan={11}
            rightColSpan={4}
            centerColSpan={3}
            leftColSpan={4}
            centerSection={centerSectionPrint}
            rightSection={rightSectionPrint}
            columns={columns}
          />
          <tbody>
            {printInfo.map((product, index) => (
              <tr key={'i' + index}>
                <td>{index + 1}</td>
                <td>{product.invoiceId}</td>
                <td>{product.invoiceNum}</td>
                <td>{product.productQuantityCount == '0' ? '-' : product.productQuantityCount}</td>
                <td>{product.productQuantityValue}</td>
                <td>{product.productUnitTitle}</td>
                <td className="priceCell">{accounting.formatMoney(product.totalAmount, '', ',')}</td>
                <td className="priceCell">
                  {accounting.formatMoney(
                    Number(product.discountAmount) + Number(product.extraDiscountAmount),
                    '',
                    ','
                  )}
                </td>
                <td className="priceCell">{accounting.formatMoney(product.payableAmount, '', ',')}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={3}>مجموع</td>
              <td colSpan={1}>{aggregation.productQuantityCount}</td>
              <td colSpan={1}>{aggregation.productQuantityValue}</td>
              <td />
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.totalAmount, '', ',')}
              </td>
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.discountAmount + aggregation.extraDiscountAmount, '', '')}
              </td>
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.payableAmount, '', ',')}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}
export default ProductFactorPrintComponent
